export const getImageUrl = (path: string) => {
  if (!path) return "";
  // Якщо path вже повний URL, повертаємо як є
  if (path.startsWith("http://") || path.startsWith("https://")) {
    return path;
  }
  // Якщо path починається з /, додаємо базовий URL
  const baseUrl = process.env.REACT_APP_BASE_API?.replace("/backend/api", "") || process.env.REACT_APP_SERVER_URL || "";
  return `${baseUrl}${path}`;
};
